import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { collection as libxCollection } from 'libx';
import { action, observe } from 'mobx';
import { Observable, from } from 'rxjs';
import { concatMap, share } from 'rxjs/operators';
export function collection(collectionOpts) {
  var setOpts = {
    stripUndefined: true,
    parse: true
  };
  collectionOpts = _objectSpread({
    getDataId: function getDataId(attrs) {
      return attrs && attrs[collectionOpts.idAttribute || 'id'];
    },
    getModelId: function getModelId(existing) {
      return existing[collectionOpts.idAttribute || 'id'];
    }
  }, collectionOpts);
  var collectionInstance = libxCollection(_objectSpread(_objectSpread({}, collectionOpts), {}, {
    create: function create(attributes) {
      var opts = {
        stripUndefined: true,
        parse: true
      };
      var instance = collectionOpts.create(attributes);
      instance.set(attributes, opts);
      return instance;
    },
    update: function update(existing, input) {
      return existing.set(input, setOpts);
    }
  }));

  // This is used to make sure we don't emit double removals when resetting the internal collection
  // array in reset([])
  var silenceRemovals = false;
  collectionInstance.reset = action(function (data) {
    if (!data) {
      return collectionInstance;
    }
    var getDataId = collectionOpts.getDataId;
    var getModelId = collectionOpts.getModelId;
    var dataMap = new Map(data.map(function (d) {
      return [getDataId(d, collectionOpts), true];
    }));
    var itemsBeforeSet = collectionInstance.slice();
    var newItems = collectionInstance.set(data);
    // Remove elements that are no longer there.
    // Go through the proper method to make sure the internal ID cache is
    // updated.
    itemsBeforeSet.forEach(function (model) {
      var isInData = dataMap.has(getModelId(model, collectionOpts));
      if (!isInData) {
        collectionInstance.remove(model);
      }
    });

    // Replace the internal array with the new items to get the proper ordering.
    silenceRemovals = true;
    collectionInstance.items.replace(newItems);
    silenceRemovals = false;
    return collectionInstance;
  });
  collectionInstance.removals$ = new Observable(function (observer) {
    var dispose = observe(collectionInstance.items, observer.next.bind(observer));
    return function () {
      return dispose();
    };
  }).pipe(concatMap(function (change) {
    return from(change.type === 'splice' && !silenceRemovals ? change.removed : []);
  }), share());
  return collectionInstance;
}
//# sourceMappingURL=collection.js.map
